import { ListItemText } from 'lib/list';
import styled from 'styled-components';

const ContextMenuListItemText = styled(ListItemText)``;

export { ContextMenuListItemText };
